import { createContext } from 'react';

const SamContext = createContext(null);

export default SamContext;
